import { useMemo } from 'react';
import { useCanvasEntities, useCanvasGroups } from '../stores/CanvasContext';
import { useHiddenLayerIds } from './useHiddenLayerIds';
import { getHandler } from '../entities/registry';
import { buildGroupBoundsMap } from '../lib/buildGroupBoundsMap';

export function useGroupBoundsMap() {
  const entities = useCanvasEntities();
  const groups = useCanvasGroups();
  const hiddenLayerIds = useHiddenLayerIds();

  const layerHiddenNodeIds = useMemo(() => {
    if (hiddenLayerIds.size === 0) return new Set<string>();
    const set = new Set<string>();
    for (const e of entities) {
      if (hiddenLayerIds.has(e.layerId)) set.add(e.id);
    }
    return set;
  }, [entities, hiddenLayerIds]);

  const memberRectMap = useMemo(() => {
    const map = new Map<string, { x: number; y: number; width: number; height: number }>();
    for (const e of entities) {
      if (!getHandler(e.kind).hasOwnRect) continue;
      map.set(e.id, { x: e.x, y: e.y, width: e.width, height: e.height });
    }
    return map;
  }, [entities]);

  return useMemo(
    () => buildGroupBoundsMap(groups, memberRectMap, layerHiddenNodeIds),
    [memberRectMap, groups, layerHiddenNodeIds],
  );
}
